export const categories = [
  {
    type: 'movie',
    label: '电影',
    icon: 'ri-film-line',
    desc: '汇聚科幻、悬疑、剧情、动作等多元题材的高清电影佳作，第一时间发现值得一看的新片。',
    accent: 'primary',
  },
  {
    type: 'tv',
    label: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '热播剧集、经典长剧与口碑佳作，都市、历史、悬疑、情感一网打尽，追剧不再错过。',
    accent: 'accent',
  },
  {
    type: 'variety',
    label: '综艺',
    icon: 'ri-mic-line',
    desc: '真人秀、音乐、美食、喜剧与旅行综艺，放松时刻的快乐来源，准时更新精彩不停。',
    accent: 'secondary',
  },
  {
    type: 'short',
    label: '短视频',
    icon: 'ri-video-line',
    desc: '一分钟看懂世界的轻内容，生活、萌宠、美食与创意剪辑，通勤路上的快乐补给。',
    accent: 'primary',
  },
];

export const regions = ['全部', '中国大陆', '美国', '韩国', '日本', '中国香港', '英国', '法国', '泰国'];

export const years = ['全部', '2026', '2025', '2024', '2023', '2022', '2021', '2020', '2019'];

export const sortOptions = [
  { value: 'latest', label: '最新' },
  { value: 'hot', label: '最热' },
  { value: 'rating', label: '评分高' },
];